import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, IconButton, InputLabel, MenuItem, Select, Slide, Snackbar, TextField } from "@mui/material";
import styles from "../../smartdevicedetails.module.css";
import { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { toast } from "react-smart-toaster";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import axios from 'axios';
import { Edit, Eye, EyeOff, Plus, Trash2, X } from "react-feather";
import OTPInput from "react-otp-input";
import dayjs from "dayjs";

const schema = yup.object().shape({
    key_type: yup.string().required("This field is Required"),
    password: yup.string().required("This field is Required").length(6, "This field is Required"),
    key_name: yup.string().when('key_type', (key_type) => {
        if (key_type && (key_type === "Tenant")) return yup.string();
        return yup.string().required('This field is Required');
    }),
    tenant_info_id: yup.object().when('key_type', (key_type) => {
        if (key_type && (key_type === "Tenant")) return yup.object().required('This field is Required').nullable();
        else return yup.object().nullable();
    }),
});

const schemaUpdate = yup.object().shape({
    password: yup.string().required("This field is Required").length(6, "This field is Required"),
});

const TTDoorLockcontrollerPin = ({ deviceDetails, setLoading, noOfSync }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [allPasswordList, setAllPasswordList] = useState([]);
    const [passwordList, setPasswordList] = useState([]);
    const [addPinState, setAddPinState] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [deleteId, setDeleteId] = useState(0);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMsg, setSnackbarMsg] = useState("");
    const [resetPinState, setResetPinState] = useState(false);
    const [resetPinData, setResetPinData] = useState(null);
    const [keyType, setKeyType] = useState("");
    const [tenantList, setTenantList] = useState([]);

    const { handleSubmit, control, errors, setValue, clearErrors } = useForm({
        resolver: yupResolver(schema),
        mode: "onChange"
    });

    const { handleSubmit: handleSubmitUpdate, control: controlUpdate, errors: errorsUpdate } = useForm({
        resolver: yupResolver(schemaUpdate),
        mode: "onChange",
        defaultValues: {
            'password': '',
        }
    });

    useEffect(() => {
        const getList = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            await axios.get(process.env.REACT_APP_DEVICE_API_URL + "v1/ttlock/lock-passcodes/" + deviceDetails?.id, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }).then((response) => {
                setAllPasswordList(response.data.data);
            }).catch((error) => {
                setAllPasswordList([]);
            });
        }

        if (deviceDetails?.id) {
            getList();
        }

    }, [deviceDetails, getAccessTokenSilently, noOfSync]);

    useEffect(() => {
        if (allPasswordList.length) {
            let passwordListTemp = allPasswordList?.map(i => {
                if (i?.password_id === '')
                    return null;

                return { ...i, p_type: "password", p_val: '000000' };
            });

            setPasswordList(passwordListTemp);
        }
    }, [allPasswordList]);

    useEffect(() => {
        const fetchTenantListByProperty = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            await axios.get(process.env.REACT_APP_DEVICE_API_URL + "v1/tenant-list-property/" + deviceDetails?.property_id, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setTenantList(response.data.data);
            }).catch((error) => {
            });
        }

        const fetchTenantListByApartment = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            await axios.get(process.env.REACT_APP_DEVICE_API_URL + "v1/device-tenant-list/" + deviceDetails?.apt_id, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                let tList = response.data.data?.map(i => {
                    return { id: i?.id, label: i?.full_name };
                });
                setTenantList(tList);
            }).catch((error) => {
            });
        }

        if (deviceDetails?.apt_id && deviceDetails?.apt_id > 0) {
            fetchTenantListByApartment();
        } else if (deviceDetails?.property_id && deviceDetails?.property_id > 0) {
            fetchTenantListByProperty();
        }
    }, [deviceDetails?.property_id, deviceDetails?.apt_id, getAccessTokenSilently]);

    const onError = (error) => {
        console.log('error');
        console.log(error);
    }

    const onSubmit = async (data) => {
        let postData = { password: data.password };
        if (data?.key_type === 'Tenant') {
            postData = { ...postData, key_name: data?.tenant_info_id?.label, tenant_info_id: data?.tenant_info_id?.id };
        } else {
            postData = { ...postData, key_name: data?.key_name };
        }

        postData = { ...postData, device_id: deviceDetails?.deviceID };

        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });


        axios.post(`${process.env.REACT_APP_DEVICE_API_URL}v1/ttlock/add-passcode`, postData, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then((response) => {
            setLoading(false);
            setSnackbarMsg(response?.data?.message);
            setSnackbarOpen(true);

            let newData = response?.data?.data;
            newData = { ...newData, p_type: "password", p_val: '000000' };

            setPasswordList(prev => {
                let newArr = prev;
                newArr.push(newData);
                return newArr;
            });

            setAddPinState(false);
        }).catch((error) => {
            setLoading(false);
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
        });
    }

    const viewPassword = async (passItem) => {
        if (passItem?.p_type !== "password") {
            setPasswordList(prev => {
                let newArr = prev?.map(item => {
                    if (item?.id === passItem?.id) {
                        let p_type = "password";
                        let p_val = "000000";
                        return { ...item, p_type: p_type, p_val: p_val };
                    }
                    return item;
                });
                return newArr;
            });
        } else {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios.get(`${process.env.REACT_APP_DEVICE_API_URL}v1/ttlock/decrypt-password/${passItem?.id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setPasswordList(prev => {
                    let newArr = prev?.map(item => {
                        if (item?.id === passItem?.id) {
                            let p_type = "password";
                            let p_val = "000000";
                            if (item?.p_type === "password") {
                                p_type = "text";
                                p_val = response?.data?.data;
                            }
                            return { ...item, p_type: p_type, p_val: p_val };
                        }
                        return item;
                    });
                    return newArr;
                });
            });
        }
    }

    const deletePassword = async () => {
        setLoading(true);
        setDeleteModalOpen(false);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        axios.delete(`${process.env.REACT_APP_DEVICE_API_URL}v1/ttlock/delete-passcode/${deleteId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then((response) => {
            setLoading(false);
            setSnackbarMsg(response?.data?.message);
            setSnackbarOpen(true);

            setPasswordList(prev => {
                let newArr = prev?.filter(i => i?.id !== deleteId);
                return newArr;
            });

            setDeleteId(0);
        }).catch((error) => {
            setLoading(false);
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
        });
    }

    const onUpdate = async (data) => {
        setLoading(true);
        setResetPinState(false);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        let postData = data;

        axios.post(`${process.env.REACT_APP_DEVICE_API_URL}v1/ttlock/reset-passcode/${resetPinData?.id}`, postData, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then((response) => {
            setLoading(false);

            setSnackbarMsg(response?.data?.message);
            setSnackbarOpen(true);

            setResetPinData(false);
        }).catch((error) => {
            setLoading(false);
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
        });
    }

    return (<>
        {deviceDetails?.online === 0 && (<div className={`${styles.OfflineSection}`}>
            <img src="/static/img/offline.svg" width="60px" height="60px" alt="" />
            <p>Device Is Offline</p>
        </div>)}
        {!addPinState && passwordList?.length > 0 && !resetPinState && <button className={`${styles.AddFingurprintBU}`} onClick={(e) => setAddPinState(true)}><Plus />Code</button>}
        {!addPinState && !resetPinState && passwordList?.length > 0 && <div className={`${styles.PinCodeListArea}`}>
            {passwordList?.map(i => {
                return (<div className={`${styles.PinCodeList}`}>
                    <div className={`${styles.PincodeListNameSec}`}>
                        <p className={`${styles.PincodeListNameTitle}`}>{i?.title}</p>
                        {i?.type !== 1 && <div>
                            <button onClick={(e) => { setResetPinState(true); setResetPinData(i); }}><Edit /></button>
                            <button onClick={(e) => { setDeleteModalOpen(true); setDeleteId(i?.id); }}><Trash2 /></button>
                        </div>}
                        {i?.expiration_time && <p className={`${styles.PincodeListNameSubTitle}`}>Valid till: {dayjs(i?.expiration_time).format('MM/DD/YYYY')}</p>}
                    </div>
                    <div className={`${styles.PinInputArea}`}>
                        <OTPInput
                            value={i?.p_val}
                            numInputs={6}
                            renderSeparator={<span>-</span>}
                            renderInput={(props) => <input {...props} type={i?.p_type} disabled />}
                        />
                        <button onClick={(e) => viewPassword(i)} className={`${styles.ResetPinInputBU}`}>{i?.p_type === "password" ? <Eye /> : <EyeOff />}</button>
                    </div>
                </div>);
            })}
        </div>}
        {addPinState && <div className={`${styles.Full}`}>
            <form onSubmit={handleSubmit(onSubmit, onError)}>
                <div className={`${styles.TTLockPinRow}`}>
                    <div className={`${styles.PinTypeSec} FormGroup`}>
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Type*</InputLabel>
                            <Controller
                                name="key_type"
                                control={control}
                                render={(field) => (
                                    <Select
                                        {...field}
                                        label="Type*"
                                        onChange={(e) => {
                                            field.onChange(e);

                                            setKeyType(e.target.value);
                                        }}
                                    >
                                        <MenuItem value="Tenant">Tenant</MenuItem>
                                        <MenuItem value="Other">Other</MenuItem>
                                    </Select>
                                )}
                            />
                        </FormControl>
                        {errors?.key_type && (<p className={`${styles.ErrorM}`}>{errors?.key_type?.message}</p>)}
                    </div>
                    {keyType !== 'Tenant' && <div className={`${styles.PinTypeSec} FormGroup`}>
                        <FormControl fullWidth>
                            <Controller
                                name="key_name"
                                control={control}
                                render={(field) => (<TextField
                                    {...field}
                                    id="outlined-multiline-static"
                                    label="Key Name*"
                                    variant="outlined"
                                    value={field?.value}
                                />)}
                            />
                        </FormControl>
                        {errors?.key_name && (<p className={`${styles.ErrorM}`}>{errors?.key_name?.message}</p>)}
                    </div>}
                    {keyType === 'Tenant' && <div className={`${styles.PinTypeSec} FormGroup`}>
                        <FormControl fullWidth>
                            <Controller
                                name="tenant_info_id"
                                control={control}
                                render={(field) => (<Autocomplete
                                    id="free-solo-2-demo"
                                    disableClearable
                                    options={tenantList}
                                    renderInput={(params) => (<TextField {...params} label="Tenant*" />)}
                                    onChange={(event, newValue) => {
                                        setValue('tenant_info_id', newValue);
                                        clearErrors();
                                    }}
                                />)}
                            />
                        </FormControl>
                        {errors?.tenant_info_id && (<p className={`${styles.ErrorM}`}>{errors?.tenant_info_id?.message}</p>)}
                    </div>}
                </div>

                <div className={`${styles.PinArea}`}>
                    <FormControl fullWidth>
                        <label id="demo-simple-select-label">Pin Code*</label>
                        <Controller
                            name="password"
                            control={control}
                            render={(field) => (
                                <OTPInput
                                    {...field}
                                    numInputs={6}
                                    renderSeparator={<span>-</span>}
                                    renderInput={(props) => <input {...props} />}
                                />
                            )}
                        />
                    </FormControl>
                </div>
                {errors?.password && (<p className={`${styles.ErrorM}`}>{errors?.password?.message}</p>)}
                <div className={`${styles.ButtonAreaPinCode}`}>
                    <button type="button" onClick={(e) => setAddPinState(false)} className={`${styles.ButtonVoiletLine}`}>Cancel</button>
                    <button type="submit" className={`${styles.ButtonVoiletSolid}`}>Add</button>
                </div>
            </form>
        </div>}
        {resetPinState && <div className={`${styles.Full}`}>
            <form onSubmit={handleSubmitUpdate(onUpdate)}>
                <p className={`${styles.PinCodeListTitle}`}>{resetPinData?.title}</p>
                <div className={`${styles.PinArea}`}>
                    <FormControl fullWidth>
                        <Controller
                            name="password"
                            control={controlUpdate}
                            render={(field) => (
                                <OTPInput
                                    {...field}
                                    numInputs={6}
                                    renderSeparator={<span>-</span>}
                                    renderInput={(props) => <input {...props} />}
                                />
                            )}
                        />
                    </FormControl>
                </div>
                {errorsUpdate?.password && (<p className={`${styles.ErrorM}`}>{errorsUpdate?.password?.message}</p>)}
                <div className={`${styles.ButtonAreaPinCode}`}>
                    <button type="button" onClick={(e) => { setResetPinState(false); setResetPinData(null); }} className={`${styles.ButtonVoiletLine}`}>Cancel</button>
                    <button type="submit" className={`${styles.ButtonVoiletSolid}`}>Update</button>
                </div>
            </form>
        </div>}
        {!passwordList?.length > 0 && !addPinState && !resetPinState &&
            <div className={`${styles.NoPinSec}`}>
                <div>
                    <img src="/static/img/noDoorPin.svg" alt="" />
                    <p>No Pin Codes are Available</p>
                    <button onClick={(e) => setAddPinState(true)}>Create Pin</button>
                </div>
            </div>
        }

        <Dialog
            open={deleteModalOpen}
            fullWidth
            maxWidth="sm"
            onClose={(e) => setDeleteModalOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp"
        >
            <DialogTitle id="alert-dialog-title">Are you sure you want to delete the pin code? <button onClick={(e) => setDeleteModalOpen(false)}><X /></button></DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <div className="ModalFormGroup">
                        <label className="PopupBodyText">The pin code will be removed immediately. You can't undo this action.</label>
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={(e) => deletePassword()} className="CancelPopupBU">Delete</Button>
                <Button onClick={(e) => setDeleteModalOpen(false)} className="SubmitPopupBU">Cancel</Button>
            </DialogActions>
        </Dialog>

        <Snackbar
            open={snackbarOpen}
            onClose={(e) => setSnackbarOpen(false)}
            TransitionComponent={Slide}
            message={snackbarMsg}
            autoHideDuration={10000}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            action={
                <IconButton
                    size="small"
                    aria-label="close"
                    color="inherit"
                    onClick={(e) => setSnackbarOpen(false)}
                >
                    <X />
                </IconButton>
            }
        />

    </>);
}

export default TTDoorLockcontrollerPin;